// @flow

export {Table, Table as default} from './table.component';
export {Head} from './head.component';
export {Body} from './body.component';
export {Foot} from './foot.component';
export {Row} from './row.component';
export {Cell} from './cell.component';
export {Headline} from './headline.component';
export {Subtitle} from './subtitle.component';
export {VerticalAlign, TextAlign} from './constants';
export {SyncHeight} from './sync-height';
export type {TextAlignType, VerticalAlignType} from './typedef';

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./head.component");

require("./body.component");

require("./table.component");

require("./foot.component");

require("./row.component");

require("./cell.component");

require("./subtitle.component");

require("./headline.component");

require("./constants");

require("./sync-height");

require("./typedef");
